/** Address Jesse already uses for HATmail issues with Local Nerds. */
export const LOCAL_NERDS_SUPPORT_EMAIL = 'reu@localnerds.co';

export function buildSupportMailto(input: { staffName?: string; view?: string } = {}): string {
  const subject = 'HatMail support';
  const body = [
    'Hi Local Nerds,',
    '',
    'I need help with HatMail.',
    input.staffName ? `Staff: ${input.staffName}` : null,
    input.view ? `Screen: ${input.view}` : null,
    '',
    'What happened:',
    '',
  ].filter((line): line is string => line !== null).join('\n');

  return `mailto:${LOCAL_NERDS_SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
